module.exports = __webpack_public_path__ + "img/f1-5.366f5b32.png";